import { from } from 'rxjs';
export class LazyTranslateLoader {
    getTranslation(lang) {
        return from(import(`../../../../assets/i18n/${lang}.json`));
    }
}
